<template>
  <section class="monitor-summary mb-2">
    <h2 class="h4 mb-1">
      {{ $t('Indicadores do período') }}
    </h2>
    <div class="monitor-summary__grid">
      <div
        v-for="item in items"
        :key="item.key"
        class="monitor-summary__card"
      >
        <span class="monitor-summary__value">{{ item.value }}</span>
        <span class="monitor-summary__label">{{ item.text }}</span>
        <small
          v-if="item.detail"
          class="text-muted"
        >
          {{ item.detail }}
        </small>
      </div>
    </div>
  </section>
</template>

<script>
import { formatDuration, ineligibilityReasonLabels } from '../monitor-labels'

export default {
  name: 'MonitorSummary',

  props: {
    summary: {
      type: Object,
      default: null,
    },
  },

  computed: {
    items() {
      const summary = this.summary || {}
      const total = summary.total || 0
      const percent = value => (total ? `${Math.round((value / total) * 100)}%` : '-')
      return [
        { key: 'total', text: this.$t('Vendas no pipeline'), value: total },
        {
          key: 'accepted',
          text: this.$t('Aceitas por fornecedor'),
          value: summary.acceptedBySupplier || 0,
          detail: [
            percent(summary.acceptedBySupplier || 0),
            ...(summary.acceptedBySupplierName || []).map(
              item => `${item.name || `#${item.deliverySupplierId}`}: ${item.count}`
            ),
          ].join(' · '),
        },
        {
          key: 'motoboy',
          text: this.$t('Assumidas por motoboy próprio'),
          value: summary.takenByOwnMotoboy || 0,
          detail: percent(summary.takenByOwnMotoboy || 0),
        },
        {
          key: 'manual',
          text: this.$t('Em tratativa manual'),
          value: summary.manualHandling || 0,
          detail: (summary.manualHandlingByReason || [])
            .map(item => `${this.$t(ineligibilityReasonLabels[item.reason] || 'Outros')}: ${item.count}`)
            .join(' · '),
        },
        {
          key: 'failed',
          text: this.$t('Com falha'),
          value: summary.failed || 0,
          detail: percent(summary.failed || 0),
        },
        { key: 'inProgress', text: this.$t('Em andamento'), value: summary.inProgress || 0 },
        {
          key: 'timeToAccept',
          text: this.$t('Tempo até o aceite'),
          value: formatDuration(summary.medianSecondsToAccept),
          detail: `${this.$t('mediana')} · p90 ${formatDuration(summary.p90SecondsToAccept)}`,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.monitor-summary {
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 0.75rem;
  }

  &__card {
    display: flex;
    flex-direction: column;
    padding: 0.75rem 1rem;
    border: 1px solid #d8dbe0;
    border-radius: 0.5rem;
    background: white;
  }

  &__value {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.2;
  }

  &__label {
    font-weight: 500;
  }
}
</style>
